import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "../../style/component/layout/Header.css";
import { useSearch } from "../../hooks/websiteHooks";
import { useTranslation } from "../../contexts/TranslationContext";
import { resolveImageSrc } from "../../utils/resolveImageSrc";

function Header() {
  // Initialize search functionality
  useSearch();
  const { t, currentLanguage, changeLanguage } = useTranslation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) {
        setMobileMenuOpen(false);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setMobileMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleLanguageChange = (lang) => {
    changeLanguage(lang);
  };

  return (
    <header className="header">
      <div className="header-content">
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            window.location.href = "/";
          }}
          className="logo"
        >
          <img src={resolveImageSrc("favicon.ico")} alt="Vietqubit logo" className="logo-icon" />
          <span>Vietqubit</span>
        </a>

        <button
          type="button"
          className={`menu-toggle ${mobileMenuOpen ? "active" : ""}`}
          onClick={() => setMobileMenuOpen((prev) => !prev)}
          aria-label="Toggle navigation menu"
          aria-expanded={mobileMenuOpen}
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={`header-nav ${mobileMenuOpen ? "open" : ""}`}>
          <ul className="nav-menu">
            <li>
              <NavLink to="/publications" className={({ isActive }) => (isActive ? "active" : "")}>
                {t("nav.publications")}
              </NavLink>
            </li>
            <li>
              <NavLink to="/open-source" className={({ isActive }) => (isActive ? "active" : "")}>
                {t("nav.open_source")}
              </NavLink>
            </li>
            <li>
              <NavLink to="/research" className={({ isActive }) => (isActive ? "active" : "")}>
                {t("nav.research")}
              </NavLink>
            </li>
            <li>
              <NavLink to="/webinars" className={({ isActive }) => (isActive ? "active" : "")}>
                {t("nav.Webinars")}
              </NavLink>
            </li>
            <li>
              <NavLink to="/members" className={({ isActive }) => (isActive ? "active" : "")}>
                {t("nav.members")}
              </NavLink>
            </li>
            <li>
              <NavLink to="/partners" className={({ isActive }) => (isActive ? "active" : "")}>
                {t("nav.partners")}
              </NavLink>
            </li>
            <li>
              <NavLink to="/donations" className={({ isActive }) => (isActive ? "active" : "")}>
                {t("nav.donations")}
              </NavLink>
            </li>
            <li>
              <NavLink to="/contact" className={({ isActive }) => (isActive ? "active" : "")}>
                {t("nav.contact")}
              </NavLink>
            </li>
          </ul>
        </nav>

        <div className="header-actions">
          <div className="language-selector">
            <button className={`lang-btn ${currentLanguage === "vi" ? "active" : ""}`} onClick={() => handleLanguageChange("vi")}>
              VI
            </button>
            <button className={`lang-btn ${currentLanguage === "en" ? "active" : ""}`} onClick={() => handleLanguageChange("en")}>
              EN
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
